import React from 'react';
import GrowniverseLogo from "../Photos/Logo/growniverse-logo-full-bordered.svg";
const TermsConditionsSection = () => {
  return (
    <section>
      <div style={{ padding: "10px" }}>
        <div className="terms-conditions">
          <h4 style={{ color: "white" }}>Growniverse Terms & Conditions</h4>

          <h6 style={{ color: "white" }}>1. Acceptance of Terms</h6>
          <p>
            By accessing or using Growniverse’s website, platforms, courses, certifications, internships, or related services, you agree to these Terms & Conditions.
            If you do not agree, do not use the Services.
          </p>

          <h6 style={{ color: "white" }}>2. About Growniverse</h6>
          <p>
            Growniverse provides digital courses, certification programs, and internship opportunities designed to support student learning and professional development.
            We may update or change Service offerings, features, and content at our discretion.
          </p>

          <h6 style={{ color: "white" }}>3. Eligibility</h6>
          <p>
            You must be at least 18 years old or have parental/guardian consent to enroll in Growniverse Services like our Internship Program where required by law.
          </p>

          <h6 style={{ color: "white" }}>4. Registration and Accounts</h6>
          <p>
            Users may need to create an account to access certain Services. You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account.<br />
            Notify Growniverse immediately of any unauthorized use or suspected breach of your account.
          </p>

          <h6 style={{ color: "white" }}>5. Enrollment, Fees, and Payments</h6>
          <p>
            Course, certification, and internship fees (if any) are shown at the time of purchase and must be paid according to the specified payment methods.<br />
            All fees are non-transferable unless otherwise specified.<br />
            Growniverse reserves the right to change pricing and fees; changes will not affect purchases already completed.
          </p>

          <h6 style={{ color: "white" }}>6. Course Content and Use</h6>
          <p>
            Growniverse provides course materials, videos, assessments, and other educational content (collectively “Content”) for personal, non-commercial use in connection with enrolled courses.<br />
            Content is protected by copyright and other intellectual property laws. You may not copy, distribute, modify, reproduce, or create derivative works from the Content except as expressly permitted by Growniverse in writing.<br />
            You may download or print limited portions of Content for personal study only, where download/print options are provided.
          </p>

          <h6 style={{ color: "white" }}>7. Certifications and Assessments</h6>
          <p>
            Certification eligibility and requirements are described with each certification program. Certifications are awarded based on completion of required coursework and assessments.<br />
            Growniverse reserves the right to revoke or suspend certifications if obtained through fraud, plagiarism, or violation of these Terms.
          </p>

          <h6 style={{ color: "white" }}>8. Internships</h6>
          <p>
            Internship offerings, duration, and requirements will be specified in the internship description. Acceptance into an internship program may depend on application review, interview, or other criteria.<br />
            Growniverse makes reasonable efforts to connect students with internship opportunities but does not guarantee job placement or employment outcomes.<br />
            Intern responsibilities, conduct, and confidentiality obligations will be specified in the internship agreement or onboarding materials.
          </p>

          <h6 style={{ color: "white" }}>9. Student Conduct and Academic Integrity</h6>
          <p>
            Students must act honestly and follow rules related to coursework and assessments. Plagiarism, cheating, falsifying credentials, or other dishonest conduct is prohibited.<br />
            Violation of academic integrity may result in failing grades, suspension, termination of access, or revocation of certifications.
          </p>

          <h6 style={{ color: "white" }}>10. Refunds and Cancellations</h6>
          <p>
            Refund and cancellation policies will be provided where applicable at the time of purchase. If no separate refund policy is posted, contact Growniverse support for assistance.<br />
            Growniverse may cancel or reschedule courses or internships due to insufficient enrollment, instructor availability, or other operational reasons. In such cases, we will offer alternatives or refunds as appropriate.
          </p>

          <h6 style={{ color: "white" }}>11. Privacy and Data Protection</h6>
          <p>
            Growniverse collects and processes personal data in accordance with its Privacy Policy. By using the Services, you consent to data collection and use as described in that policy.<br />
            Growniverse takes reasonable steps to protect personal data but cannot guarantee absolute security of information transmitted online.
          </p>

          <h6 style={{ color: "white" }}>12. Disclaimers and Limitation of Liability</h6>
          <p>
            Services and Content are provided "as is" without warranties of any kind, whether express or implied. Growniverse does not guarantee specific learning outcomes, employment, or income resulting from use of the Services.<br />
            To the maximum extent permitted by law, Growniverse will not be liable for indirect, incidental, special, consequential, or exemplary damages arising out of or in connection with the Services.
          </p>

          <h6 style={{ color: "white" }}>13. Intellectual Property</h6>
          <p>
            All intellectual property rights in the Growniverse brand, trademarks, logos, and Content belong to Growniverse or its licensors. You obtain no ownership rights by using the Services.
          </p>

          <h6 style={{ color: "white" }}>14. Third-Party Links and Resources</h6>
          <p>
            The Services may include links to third-party websites or resources. Growniverse does not endorse and is not responsible for third-party content, terms, or practices.
          </p>

          <h6 style={{ color: "white" }}>15. Modification and Termination</h6>
          <p>
            Growniverse may modify these Terms, Service features, or policies at any time. Continued use of the Services after changes constitutes acceptance of the revised Terms.<br />
            Growniverse may suspend or terminate access to the Services for violation of these Terms or other policies, or for operational reasons.
          </p>

          <h6 style={{ color: "white" }}>16. Contact Information</h6>
          <p>
            For questions about these Terms, refunds, or support, contact: <a href="mailto:admin@growniverse.com"  style={{color:"white"}}>admin@growniverse.com</a>
          </p>

          <h6 style={{ color: "white" }}>17. Acceptance</h6>
          <p>
            By enrolling in or using Growniverse Services, you acknowledge that you have read, understood, and agree to these Terms & Conditions.
          </p>
        </div>

        <img src={GrowniverseLogo} width={"20%"} alt='Growniverse' />
        <p>
          GROWNIVERSE<br />
          A UNIVERSE WHERE YOU GROW
        </p>
      </div>
    </section>
  );
};

export default TermsConditionsSection;
